import { ref } from "vue";
import axios from "axios";

// 하나 바이블 부서별 게시판 (영유아부 ~ 구역/장년)
export const HANA_BIBLE_DEPT_BOARD_IDS = [5, 6, 7, 8, 9, 10, 11];

export const isHanaBibleDeptBoard = (boardId) =>
  HANA_BIBLE_DEPT_BOARD_IDS.includes(Number(boardId));

// 전역 게시판 계층 목록 (boards[].subBoards[]) - 한 번만 조회해서 공유
const boardTree = ref([]);
let boardTreeRequest = null;

/**
 * 게시판 계층 목록 조회 (이미 조회했으면 재요청하지 않음)
 */
export const loadBoardTree = () => {
  if (!boardTreeRequest) {
    boardTreeRequest = axios
      .get("/new_api/board/list")
      .then((res) => {
        boardTree.value = res.data?.data?.boards || [];
      })
      .catch((err) => {
        boardTreeRequest = null; // 실패 시 다음 호출에서 재시도
        console.error(err);
      });
  }
  return boardTreeRequest;
};

/**
 * boardId 가 부서 게시판 자체이거나 그 하위 게시판이면 해당 부서 게시판을 반환
 */
export const findHanaBibleDeptBoard = (boardId) => {
  const id = Number(boardId);
  return boardTree.value.find(
    (board) =>
      isHanaBibleDeptBoard(board.boardId) &&
      (board.boardId === id ||
        board.subBoards?.some((sub) => sub.boardId === id)),
  );
};

/**
 * 게시판 계층 목록 composable
 */
export const useBoardTree = () => {
  return {
    boardTree,
    loadBoardTree,
    findHanaBibleDeptBoard,
  };
};
